import React, { useEffect, useState } from "react";
import { BarChart } from "@mui/x-charts/BarChart";
import {
  BarChart as RechartsBarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  LabelList,
} from "recharts";
const rawDataWeek = [
  { Lable: "20", Score1: 2, Score2: 3, Score3: 4 },
  { Lable: "21", Score1: 2, Score2: 3, Score3: 4 },
  { Lable: "22", Score1: 3, Score2: 4, Score3: 2 },
  { Lable: "23", Score1: 4, Score2: 2, Score3: 3 },
  { Lable: "24", Score1: 2, Score2: 3, Score3: 4 },
  { Lable: "25", Score1: 3, Score2: 4, Score3: 2 },
];

const rawData2 = [
  { Lable: "January", Score1: 2, Score2: 3, Score3: 4 },
  { Lable: "February", Score1: 2, Score2: 3, Score3: 4 },
  { Lable: "March", Score1: 3, Score2: 4, Score3: 2 },
  { Lable: "April", Score1: 4, Score2: 2, Score3: 3 },
  { Lable: "May", Score1: 2, Score2: 3, Score3: 4 },
  { Lable: "June", Score1: 3, Score2: 4, Score3: 2 },
];

const rawDataDay = [
  { Lable: "1 June", Score1: 2, Score2: 3, Score3: 4 },
  { Lable: "2 June", Score1: 2, Score2: 3, Score3: 4 },
  { Lable: "3 June", Score1: 3, Score2: 4, Score3: 2 },
  { Lable: "4 June", Score1: 4, Score2: 2, Score3: 3 },
  { Lable: "5 June", Score1: 2, Score2: 3, Score3: 4 },
  { Lable: "6 June", Score1: 3, Score2: 4, Score3: 2 },
  { Lable: "7 June", Score1: 2, Score2: 3, Score3: 4 },
  { Lable: "8 June", Score1: 3, Score2: 4, Score3: 2 },
  { Lable: "9 June", Score1: 2, Score2: 3, Score3: 4 },
  { Lable: "10 June", Score1: 3, Score2: 4, Score3: 2 },
  { Lable: "12 June", Score1: 4, Score2: 2, Score3: 3 },
  { Lable: "13 June", Score1: 2, Score2: 3, Score3: 4 },
  { Lable: "14 June", Score1: 3, Score2: 4, Score3: 2 },
  { Lable: "15 June", Score1: 2, Score2: 3, Score3: 4 },
  { Lable: "16 June", Score1: 3, Score2: 4, Score3: 2 },
  { Lable: "17 June", Score1: 4, Score2: 2, Score3: 3 },
  { Lable: "18 June", Score1: 2, Score2: 3, Score3: 4 },
  { Lable: "19 June", Score1: 3, Score2: 4, Score3: 2 },
  { Lable: "20 June", Score1: 4, Score2: 2, Score3: 3 },
];
const dataX = [
  {
    Lable: "June 2024",
    Good: 10,
    Bad: 1,
    "Very Good": 19,
  },
  {
    Lable: "July 2024",
    Good: 14,
    Bad: 1,
    "Very Good": 35,
  },
  {
    Lable: "August 2024",
    Good: 2,
    Bad: 0,
    "Very Good": 2,
  },
];
const renderCustomLabel = (props) => {
  const { x, y, width, value } = props;
  const radius = 10;
  return (
    <text
      x={x + width / 2}
      y={y - radius}
      fill="#666"
      textAnchor="middle"
      dominantBaseline="middle"
      fontSize="10" // Add font size here
    >
      {`${value}%`}
    </text>
  );
};

const calculatePercentageData = (data) => {
  return data.map((item) => {
    const total = item.Good + item.Bad + item["Very Good"];
    return {
      Lable: item.Lable,
      Good: ((item.Good / total) * 100).toFixed(2),
      Bad: ((item.Bad / total) * 100).toFixed(2),
      "Very Good": ((item["Very Good"] / total) * 100).toFixed(2),
    };
  });
};
const MyBarChart2 = ({ context, timeInterval, rawData }) => {
  const [xAxisData, setXAxisData] = useState([]);
  const [series1Data, setSeries1Data] = useState([]);
  const [series2Data, setSeries2Data] = useState([]);
  const [series3Data, setSeries3Data] = useState([]);

  useEffect(() => {
    let data = StructureData(rawData);
    setXAxisData(data.xAxisData);
    setSeries1Data(data.series1Data);
    setSeries2Data(data.series2Data);
    setSeries3Data(data.series3Data);
  }, [rawData]);

  const StructureData = (data) => {
    const xAxisData = [];
    const series1Data = [];
    const series2Data = [];
    const series3Data = [];
    data.forEach((ele) => {
      xAxisData.push(ele.Lable);
      series1Data.push(ele["Good"]);
      series2Data.push(ele["Bad"]);
      series3Data.push(ele["Very Good"]);
    });
    return {
      xAxisData,
      series1Data,
      series2Data,
      series3Data,
    };
  };
  const percentageData = calculatePercentageData(rawData);
  const getChartLabel = () => {
    if (timeInterval == 2) {
      return "Days";
    } else if (timeInterval == 3) {
      return "Weeks";
    } else {
      return "Month";
    }
  };

  return (
    <>
      {/* <BarChart
        xAxis={[
          {
            data: xAxisData,
            scaleType: "band",
            label: getChartLabel(),
          },
        ]}
        yAxis={[
          {
            label: "Average Rating",
          },
        ]}
        series={[
          {
            data: series1Data,
            label: "Good",
          },
          {
            data: series2Data,
            label: "Bad",
          },
          {
            data: series3Data,
            label: "Very Good",
          },
        ]}
        height={400}
      /> */}
      <div style={{ width: "100%", overflowX: "auto" }}>
        <div style={{ width: "1500px" }}>
          {" "}
          {/* Adjust width as needed */}
          <ResponsiveContainer width="100%" height={500}>
            <RechartsBarChart
              data={percentageData}
              margin={{
                top: 5,
                right: 5,
                left: 5,
                bottom: 5,
              }}
            >
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="Lable" />
              <YAxis />
              <Tooltip />
              <Legend />
              <Bar dataKey="Good" fill="#8884d8" barSize={30}>
                <LabelList dataKey="Good" content={renderCustomLabel} />
              </Bar>
              <Bar dataKey="Bad" fill="#82ca9d" barSize={30}>
                <LabelList dataKey="Bad" content={renderCustomLabel} />
              </Bar>
              <Bar dataKey="Very Good" fill="#2e86c1" barSize={30}>
                <LabelList dataKey="Very Good" content={renderCustomLabel} />
              </Bar>
            </RechartsBarChart>
          </ResponsiveContainer>
        </div>
      </div>

      {console.log(rawData)}
    </>
  );
};

export default MyBarChart2;
